'use client';

import { History } from '@repo/types';
import { CalendarCheck } from 'lucide-react';

interface TravauxDateEcheanceProps {
  history: History;
}

function formatDateOnly(dateString: string | Date | null | undefined): string {
  if (!dateString) return 'Date inconnue';
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  } catch {
    return 'Date invalide';
  }
}

export function TravauxDateEcheance({ history }: TravauxDateEcheanceProps) {
  return (
    <div className="space-y-2">
      <label className="text-sm font-semibold text-gray-900 flex items-center gap-2">
        <CalendarCheck className="h-4 w-4 text-primary" />
        Date échéance initiale
      </label>
      <div className="bg-gray-50 border border-gray-200 rounded-lg px-4 py-3 min-h-[2.5rem] flex items-center transition-all duration-200 hover:border-gray-300 hover:bg-gray-100/50">
        <span className="text-sm text-gray-900 font-medium">
          {formatDateOnly(history.user_edited_date_travaux)}
        </span>
      </div>
    </div>
  );
}
